import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ArticleHero = ({ title, author, publishedAt, heroImage, heroImageAlt, content }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const calculateReadTime = (contentText) => {
    const wordsPerMinute = 200;
    const wordCount = contentText?.split(/\s+/)?.length;
    return Math.ceil(wordCount / wordsPerMinute);
  };

  return (
    <div className="w-full">
      <div className="relative w-full h-64 md:h-80 lg:h-96 overflow-hidden rounded-lg mb-6 md:mb-8 lg:mb-10">
        <Image
          src={heroImage}
          alt={heroImageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" />
      </div>
      <div className="space-y-4 md:space-y-5 lg:space-y-6">
        <div className="flex flex-wrap items-center gap-3 md:gap-4 text-sm md:text-base text-muted-foreground">
          <div className="flex items-center gap-2">
            <Icon name="Calendar" size={16} color="var(--color-primary)" />
            <time dateTime={publishedAt}>{formatDate(publishedAt)}</time>
          </div>
          <span className="text-muted-foreground/50">•</span>
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={16} color="var(--color-primary)" />
            <span>{calculateReadTime(content)} min read</span>
          </div>
          <span className="text-muted-foreground/50">•</span>
          <div className="flex items-center gap-2">
            <Icon name="User" size={16} color="var(--color-primary)" />
            <span>{author}</span>
          </div>
        </div>

        <h1 className="text-2xl font-semibold text-foreground leading-tight">
          {title}
        </h1>
      </div>
    </div>
  );
};

export default ArticleHero;